export default __webpack_public_path__ + "static/media/stochsd.498eb290.png";